import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ResetPassword as NewResetPassword } from '@cokitchen/cokitchen-auth';
import Logo from 'assets/logo.svg';
import { LoginEnvType } from '@cokitchen/cokitchen-auth/dist/lib/login/types';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { ROUTE_KEYS } from 'utils/constants';

const ResetPassword = () => {
  const { token }: any = useParams();
  const navigate = useNavigate();
  const login = () => {
    navigate('/login');
  };
  const authEnvironment = process.env.REACT_APP_AUTH_ENVIRONMENT as LoginEnvType;

  const onSuccess = () => {
    toast(<ToastMessage message='Reset password successfully' type='success' />);
    navigate(ROUTE_KEYS.LOGIN);
  };
  return (
    <div className='auth-login__main min-h-screen bg-white px-0  md:px-16 pt-8'>
      <div className='flex justify-between items-center bg-white'>
        <div>
          <img src={Logo} className='auth-login__logo' alt='Food court' />
        </div>
        <p className='bg-[#F2F2F2] rounded-[6px] px-5 py-3 px-auto'>Main store</p>
      </div>
      <main className='auth-login__card mt-[5rem]'>
        <NewResetPassword
          env={authEnvironment}
          token={token}
          onRouteToLogin={login}
          description='Enter and confirm a new password'
          isAuthenticated={false}
          onSuccess={onSuccess}
        />
      </main>
    </div>
  );
};

export default ResetPassword;
